import crownUrl from "../../assets/icons/crown.svg";

export default function CrownIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <img
      src={crownUrl}
      alt=""
      className={className}
      aria-hidden="true"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
        objectFit: "contain",
      }}
    />
  );
}
